/*eslint-disable */
var clearTimeoutState;

import Vue from 'vue'
import allCountries from '@/services/phoneCodeList.json';
import {bus} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'signup',
  components: {
  },
  props: [],
  data () {
    return {
      first_name:'',
      last_name:'',
      email:'',
      password:'',
      confirm_password:'',
      submitted:false,
      phone: {
        number: '',
        isValid: false,
        country: '',
        countryIso: ''
      },
      allCountriesList: [],
      open:false,
      accept_terms:'',
      phoneNumber:{
        fullOTP:''
      },
      signUpFormMain:true,
      signUpFormVerify:false,
      signUpFormVerifyPopup:false,
      gender:'',
      dob:'',
      countDown: 30,
      resentOtpFlag:false,
      phoneNumberBlurState:false
    }
  },
  computed: {

  },
  mounted () {
    bus.$emit('headerDisabledBus', false);
    if (localStorage.getItem('token') != null && localStorage.getItem('LoginedUserID') != null) {
      this.$router.push('/dashboard/');
    }
    // loop over all of the countries above, restructuring the data to be objects with named keys
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    this.getUserCountry();
  },
  methods: {
    phoneNumberFocusMethod(){
      this.phoneNumberBlurState = true
    },
    phoneNumberBlurMethod(){
      this.phoneNumberBlurState = false
    },
    countDownTimer() {
      if(this.countDown > 0) {
        clearTimeoutState = setTimeout(() => {
                this.countDown -= 1
                this.countDownTimer()
            }, 1000)
        }
    },
    clickedOutside() {
      this.open = false;
    },
    toggleDropdown() {
      this.open = !this.open;
    },
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
          if (self.phone.country == '') {
            self.countryName = (text.substr(2, 2)).toLowerCase();
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.country = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
          }
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    chooseCountry(country) {
      this.phone.countryIso = country.iso2;
      this.phone.country = country.dialCode;
    },
    validateSignBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted = true;
          let data = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            mobile_country_code:'+' + this.phone.country,
            mobile:this.phone.number,
            gender:this.gender,
            // dob:this.dob,
          }
          this.$store.dispatch('authUserSignupApiFun', data).then((res) => {
              toast.success(res.data.user_msg || res.data.msg);
              this.signUpFormMain = false
              this.signUpFormVerify = true
              this.submitted =  false
              this.countDownTimer();
          }).catch((err) => {
              toast.error(err.data.user_msg);
              this.submitted =  false;
          })
          return;
        }
      })
    },
    resendOtpMethod() {    
      let data = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        mobile_country_code:'+' + this.phone.country,
        mobile:this.phone.number,
        gender:this.gender,
        // dob:this.dob,
      }
      this.$store.dispatch('resendReqSignupAction', data)
        .then((res) => {
          toast.success(res.data.user_msg || res.data.msg);
          this.countDown = 30
          this.countDownTimer();
          this.resentOtpFlag = true
        }).catch((err) => {
          toast.error(err.data.data.non_field_errors || err.data.msg || err.data.user_msg);
        })
    },
    validateSignVerifyBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            mobile_country_code:'+' + this.phone.country,
            mobile:this.phone.number,
            otp:this.phoneNumber.fullOTP,
            signup_type:this.signup_type,
          }
          this.$store.dispatch('signUpVerifyAction', data)
            .then((res) => {  
              document.getElementById('preloader').style.display = "flex";
              toast.success(res.data.msg);
              this.submitted = false;
              bus.$emit('headerDisabledBus', true);
              this.$router.push('/dashboard/');
            }).catch((err) => {
              toast.error(err.data.user_msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
  },
}